module.exports = __webpack_public_path__ + "static/media/icon-verified.a360b8f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-verified.svg
// module id = 526
// module chunks = 0